import React from "react";
import Applet from "../../Applet";
import AdminPositionEmployeeTable from "../../../../components/Administration/AdminPositionEmployeeTable";

class AdminPositionEmployeeTableApplet extends Applet {

    render() {
        return <AdminPositionEmployeeTable applet={this}
                                   pageSize={this.state.PageSize}
                                   placement={this.state.Placement}
                                   columns={this.state.Columns}
                                   title="Employees"
                                   enterpriseComponent={this.getEnterpriseComponent()}
                                   sort={this.state.Sort}
                                   menu={this.state.Menu}
                                   rowHeight={this.state.RowHeight}
                                   simpleSearch={this.state.SimpleSearch}
        />;
    }

    state = {
        Name: "AdminPositionEmployeeTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "Add Employee To Position",
                    value: "New Employee",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 5,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 10,
            "lx": 10,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "UserName",
                },
                {
                    id: "Email",
                },
                {
                    id: "Actions",
                },
            ],
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "UserName",
                width: 325,
                cellRenderer: "Employee Name Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "User Name",
            },
            {
                id: "Email",
                width: 325,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Email",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            },
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "UserName",
                    "DisplayName": "User Name",
                }],
            },
        ],
        SimpleSearch: {
            Actions: {
                Query: {
                    Groups: [
                        {
                            "identifier": "group1",
                            "type": "standard",
                            "selector": null,
                            "characteristics": [],
                            "membership": [
                                {
                                    id: "UserName",
                                },
                                {
                                    id: "Email",
                                }
                            ]
                        }
                    ]
                }
            },
            Controls: {
                "UserName": {
                    id: "UserName",
                    enterpriseComponentAttribute: "UserName",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "User Name",
                        disabled: false,
                        size: "small",
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "Email": {
                    id: "Email",
                    enterpriseComponentAttribute: "Email",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            xl: 6
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Email",
                        disabled: false,
                        size: "small",
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                }
            }
        }
    };
}

export default AdminPositionEmployeeTableApplet;
